module.exports = __webpack_public_path__ + "static/media/DSCF9017.a636df2c.JPG";